document.addEventListener('DOMContentLoaded', () => {

    const form = document.forms.register_promo;

    const telInput = form.querySelector('#reg-tel');
    const nameInput = form.querySelector('#reg-name');
    const codeInput = form.querySelector('#reg-code');
    const familiarizedCheck = form.querySelector('#reg-familiarized');
    const adultCheck = form.querySelector('#reg-adult');
    const agreeCheck = form.querySelector('#reg-agree');
    const btnReg = form.querySelector('.reg-btn');
    const formLoader = form.querySelector('.form-loader');


    telInput.addEventListener('focus', () => {
        if (!telInput.value || telInput.value == '+3' || telInput.value == '+') {
            telInput.value = '+38';
        }
    })

    telInput.addEventListener('blur', () => {
        if (telInput.value == '+38') {
            telInput.value = '';
        }
    })

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        let errors = []

        !codeInput.value ? codeInput.classList.add('error') : codeInput.classList.remove('error');
        !telInput.value ? telInput.classList.add('error') :
            telInput.value == '+38' ? telInput.classList.add('error') : telInput.classList.remove('error');
        console.log(telInput.value)
        !nameInput.value ? nameInput.classList.add('error') : nameInput.classList.remove('error');

        !familiarizedCheck.checked ? familiarizedCheck.classList.add('error') : familiarizedCheck.classList.remove('error');
        !adultCheck.checked ? adultCheck.classList.add('error') : adultCheck.classList.remove('error');
        !agreeCheck.checked ? agreeCheck.classList.add('error') : agreeCheck.classList.remove('error');

        if (!document.querySelector('input.error')) {
            let formData = new FormData(form)
            onSubmitAction(formData)
            hideBtn(btnReg, formLoader)
        }

    })

    async function onSubmitAction(form) {
        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: form,
        });

        const result = await response.json();


        if (result.status === 'success') {
            showPopUp("Вітаємо!", "Ваш код зареестрований", true)
            writeInGoogleSheet(form);
            form.reset();
        } else if (result.status === 'does_not_exist') {
            showPopUp("ОЙ!", "Код не знайдений", false)
            codeInput.value = '';
        } else {
            showPopUp("ОЙ!", "Цей код вжє зареєстровано", false)
            codeInput.value = '';
        }
    }

    function writeInGoogleSheet(form) {

        fetch('https://script.google.com/macros/s/AKfycbySydwWYBvE8Yewgr19ZybDNNqADRPI4IsAOFAjVWkp51DvgBo/exec?' + new URLSearchParams({
            'promocode': form.get('promocode'),
            'name': form.get('name'),
            'number': form.get('number'),
            'currentDate': new Date().toLocaleDateString()
        }), {
            method: 'GET',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'Application/X-Www-Form-Urlencoded'
            },
        })

    }

    const popUp = document.querySelector('.pop-up-congratulation');
    const popUpContent = popUp.querySelector('.pop-up-content')
    const popUpTitle = popUp.querySelector('h3');
    const popUpText = popUp.querySelector('p');
    const popUpClear = popUp.querySelector('.btn-clear');

    function showPopUp(title, text) {
        popUpTitle.innerHTML = title;
        popUpText.innerHTML = text;
        popUp.style.display = 'block';

    }

    popUpClear.addEventListener('click', function (){
        popUpTitle.innerHTML = "";
        popUpText.innerHTML = "";
        popUp.style.display = 'none';
        showBtn(btnReg, formLoader)
    })

    function hideBtn(btn, loader) {
        btn.style.display = 'none';
        loader.style.display = 'flex';
    }

    function showBtn(btn, loader) {
        btn.style.display = 'block';
        loader.style.display = 'none';
    }
})